var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 42 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1,1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0,
    y: 0,
    width: "40px",
    height: "38px"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "40px",
    height: "38px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAmCAYAAAC29NkdAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADqklEQVRYhb2YT2gbVxCHv3mWbUHwWtCKYJKDemoOaeISQktwsYKh5GSnl0JziXJpjpZyLA2JIO0xuLemFCJfXEgvVntILqEyuI3bYKy0gbaHEhUaSqqkVTYO2PJqpwfJsizJlvdP8oOFZfe92Y83++bNjOBTtmqMGklVEn2Gowox6hcAAiVX+RMo0EfREqn4+Y54hVKHlDFMAUmP3yqoMqsOheGolEIFtFVjBqa1RhrZWiVfUkrSx3xtnc/2AtoT8LnqtFvjcmCwdiklhawVkdxuw3YEtFVj4nIdOB0qWCdAzjVkdvpHuwLaqgmp8R1C4kXCNaWUXIeT3VzeAfjS4Ta1A+Q2QFs1JjVWXjrclopqONnqbtP61sClsOAelJ/4mTZq4FIbU122oyl1SQcFA5hbWubc7NdcW/jB81x1SduOJjsApY3cr75Zuc8Xi3cBGLEsXzYErm/eG6ivXhiufVD+l6u3FwH44PgRJt887M+QkLAdTTUBBaaDwpXtVT7O3wTg0P5XOT9+IpA9Ec4CyNOqjpo+VoLCpW/keVh5xoHYEDPvTxK3hgIBAvQbEgbxfOh36GL+VuhwAOsO7xkjjAcxcm3hDr89egzAJ1OnQoMDECFpwP/mmFta5qu79wC4MDFGIv5KSGh1CRz1DdgaTj5857j/Hbu7YsZPGlW2V/ny+5+Aejg589ax0MkAEGKm96hO/VF+gr1WxYoOBA4nvWRQSkEM/GOvhoTSRUrFAJ6LmTcOjmBFB7HXqlzM3+L5evUF0IFC0Sjc8zpx3+AAn54+BcDvjx7z+cKd0OEAEEoGKPiZe/jgCJmJMQC+/flX5n5cDpGsIWVBGrXHf35tzC0tN8PNhYmxUMONu8FrppG9FvwaOfP2MSaPHALg6u1F7v/1dyhwCrnhqJQMgCrZIMbOj5/g9f1xAD6avxnOzlZmoZFuWREpEGAV9w0OcGXqXQ7EhrDXqmRu5ANBKuQaTFsZtRrOod5DzqbiVj2TsaKDPKw88x9+lIpubHm0CWiJlNyAro5bQ9vCT774i2cbrpJtLT23HXXD/TIT9H9sDT9epUp2uF9mWp917yw4OiMSvAzwIlVmrYik2p93TRasiKSDrqQXqZLtBgc9ulu2oykJsZjvkFJRyOzW4erZfrNVE9S4vFllhcfGvG6Q6dUj3HOHNSxQVQrU+4KFvYz31AKGJmgSOCsw2jMjr7uxqEpeIuS89qo9A7braVVHxRCjs7apqEPRSz+6m/4Hk5tt3VfkiWQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.e96a1d56102efd8f738518816e329c44.svg";
export { ForwardRef as ReactComponent };